/* ==========================================================================
   td-product.js  --  tabs / accordion, gallery, service picker, countdown.

   Everything is scoped to [data-td-product] and looked up per-root, so two of
   these on one page cannot fight over each other's elements.
   ========================================================================== */
(function () {
  "use strict";

  function init(root) {
    if (root.dataset.tdReady) return;
    root.dataset.tdReady = "1";

    /* ---------- tabs ------------------------------------------------------ */
    var bar = root.querySelector(".pv-tabbar");
    if (bar) {
      var tabs = [].slice.call(bar.querySelectorAll(".pv-tab"));
      var pans = tabs.map(function (t) {
        return root.querySelector("#" + CSS.escape(t.getAttribute("aria-controls")));
      });
      var show = function (i, push) {
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle("is-on", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
          t.setAttribute("tabindex", on ? "0" : "-1");
          if (pans[n]) pans[n].hidden = !on;
        });
        var heads = root.querySelectorAll("[data-td-acc]");
        [].forEach.call(heads, function (h, n) {
          h.setAttribute("aria-expanded", n === i ? "true" : "false");
        });
        if (push && pans[i]) history.replaceState(null, "", "#" + pans[i].id);
      };
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function (e) { e.preventDefault(); show(i, true); });
        t.addEventListener("keydown", function (e) {
          var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + tabs.length) % tabs.length;
          tabs[n].focus();
          show(n, true);
        });
      });
      /* Mobile accordion. Under 760px the tab strip is hidden and each panel's
         own header takes over -- several panels can be open at once, which is
         the point of an accordion, so this does not touch the tab state. On a
         resize back up, the tab strip takes over again and whatever the
         accordion left open is reconciled to the selected tab. */
      var accs = [].slice.call(root.querySelectorAll("[data-td-acc]"));
      var isNarrow = function () {
        return window.matchMedia("(max-width:760px)").matches;
      };
      accs.forEach(function (h) {
        h.addEventListener("click", function () {
          var panel = root.querySelector("#" + CSS.escape(h.dataset.tdAcc));
          if (!panel) return;
          var open = h.getAttribute("aria-expanded") === "true";
          h.setAttribute("aria-expanded", open ? "false" : "true");
          panel.hidden = open;
        });
      });
      var reconcile = function () {
        if (isNarrow()) return;              /* accordion owns it below 760 */
        var i = tabs.findIndex(function (t) { return t.classList.contains("is-on"); });
        show(i < 0 ? 0 : i, false);
        accs.forEach(function (h, n) {
          h.setAttribute("aria-expanded", n === (i < 0 ? 0 : i) ? "true" : "false");
        });
      };
      window.addEventListener("resize", reconcile);

      /* a link straight to a panel opens that tab */
      var h = location.hash.replace("#", "");
      var start = -1;
      pans.forEach(function (p, i) { if (p && p.id === h) start = i; });
      show(start > -1 ? start : 0, false);
    }

    /* ---------- gallery --------------------------------------------------- */
    var main = root.querySelector(".pv-main img");
    [].forEach.call(root.querySelectorAll(".pv-thumb"), function (b) {
      b.addEventListener("click", function () {
        [].forEach.call(root.querySelectorAll(".pv-thumb"), function (x) {
          x.classList.remove("is-on");
        });
        b.classList.add("is-on");
        if (main) {
          var img = b.querySelector("img");
          main.src = img.src.replace(/width=\d+/, "width=900");
          main.srcset = "";
        }
      });
    });

    /* ---------- service picker -------------------------------------------
       The label carries the variant id; the hidden select is what the cart
       posts. Keeping the price in sync matters -- a shopper who picks Fitted
       and still sees the tyre-only price will think they have been overcharged
       at checkout.                                                          */
    var sel = root.querySelector("[data-td-variant]");
    var priceEl = root.querySelector("[data-td-price]");
    var quarterEl = root.querySelector("[data-td-quarter]");
    var money = function (cents) {
      return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    [].forEach.call(root.querySelectorAll(".pv-svc__o .pv-opt"), function (o) {
      o.addEventListener("click", function () {
        [].forEach.call(root.querySelectorAll(".pv-svc__o .pv-opt"), function (x) {
          x.classList.remove("is-on");
        });
        o.classList.add("is-on");
        var id = o.dataset.variantId;
        var cents = parseInt(o.dataset.price, 10);
        if (sel && id) {
          sel.value = id;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (priceEl && !isNaN(cents)) priceEl.textContent = money(cents);
        if (quarterEl && !isNaN(cents)) quarterEl.textContent = money(Math.round(cents / 4));
        syncService(o.hasAttribute("data-td-fitted"));
      });
    });

    /* ---------- fitting calendar ------------------------------------------
       Shown only when Fitted is selected, inline in the picker. Picking a slot
       writes hidden inputs into the add-to-cart form, so the ordinary Add to
       cart carries the booking.

       Slots come from the td-booking Worker rather than SimplyBook direct, so
       no API key ships to the browser. Asking with the real quantity matters:
       fitting four tyres needs a longer bay slot than fitting one, and the
       Worker returns fewer days for a bigger set.                            */
    var cal = root.querySelector("[data-td-cal]");
    var addBtn = root.querySelector(".pv-cart");
    var form = (addBtn && addBtn.form) || root.querySelector("form");
    var calState = { date: null, time: null, slots: null, loadedQty: null, loading: false };

    var q = function (sel) { return cal ? cal.querySelector(sel) : null; };
    var DAY = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var DIN = ["S", "M", "T", "W", "T", "F", "S"];
    var MON = ["January", "February", "March", "April", "May", "June", "July",
               "August", "September", "October", "November", "December"];
    var MSH = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
               "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    var qtyNow = function () {
      var v = qty ? parseInt(qty.value, 10) : 1;
      return isNaN(v) || v < 1 ? 1 : v;
    };
    var fmtTime = function (t) {
      var p = t.split(":"), h = parseInt(p[0], 10);
      return (h > 12 ? h - 12 : h || 12) + ":" + p[1] + (h >= 12 ? "pm" : "am");
    };
    var fmtDate = function (k, withYear) {
      var d = new Date(k + "T00:00:00");
      return DAY[d.getDay()] + " " + d.getDate() + " " + MSH[d.getMonth()] +
             (withYear ? " " + d.getFullYear() : "");
    };
    var isoOf = function (d) {
      return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") +
             "-" + String(d.getDate()).padStart(2, "0");
    };

    var fittedIsSelected = function () {
      var on = root.querySelector(".pv-opt.is-on");
      return !!(on && on.hasAttribute("data-td-fitted"));
    };

    /* the three line-item properties the order needs */
    var setProps = function (dateStr, timeStr) {
      ["Fitting Date", "Fitting Time", "Location"].forEach(function (n) {
        var old = form && form.querySelector('input[name="properties[' + n + ']"]');
        if (old) old.remove();
      });
      if (!form || !dateStr || !timeStr) return;
      [["Fitting Date", dateStr], ["Fitting Time", timeStr],
       ["Location", "31 Station Rd, Te Puke"]].forEach(function (pair) {
        var i = document.createElement("input");
        i.type = "hidden";
        i.name = "properties[" + pair[0] + "]";
        i.value = pair[1];
        form.appendChild(i);
      });
    };

    /* progress: an unbooked fitting has to look unfinished.
       Named calStep, not step -- the quantity stepper below declares its own
       `var step(n)` in this same scope, and the later assignment wins. That
       collision made every day/time click run the quantity stepper with an
       undefined delta instead of moving the progress bar. */
    var calStep = function () {
      var bar = q("[data-td-cal-prog]"), stat = q("[data-td-cal-stat]");
      var num = q("[data-td-cal-num]"), msg = q("[data-td-cal-msg]"), sum = q("[data-td-cal-sum]");
      if (!bar) return;
      if (calState.date && calState.time) {
        bar.style.width = "100%";
        stat.classList.add("is-done");
        num.innerHTML = "&#10003;";
        msg.textContent = "Fitting booked";
        sum.textContent = fmtDate(calState.date) + " at " + fmtTime(calState.time);
      } else if (calState.date) {
        bar.style.width = "66%";
        stat.classList.remove("is-done");
        num.textContent = "3";
        msg.textContent = "Choose a time";
        sum.textContent = fmtDate(calState.date);
      } else {
        bar.style.width = "33%";
        stat.classList.remove("is-done");
        num.textContent = "2";
        msg.textContent = "Choose a day";
        sum.innerHTML = "&mdash;";
      }
    };

    var confirmSlot = function () {
      var ok = q("[data-td-cal-ok]");
      /* belt and braces: a fitting date must never reach the order unless
         Fitted is the selected service. CSS hides the calendar otherwise, but
         a stale rule already defeated that once. */
      if (!fittedIsSelected() || !calState.date || !calState.time) {
        if (ok) ok.hidden = true;
        setProps(null, null);
        calStep();
        return;
      }
      var ds = fmtDate(calState.date, true), ts = fmtTime(calState.time);
      var slot = q("[data-td-cal-slot]");
      if (slot) slot.textContent = ds + " at " + ts;
      if (ok) ok.hidden = false;
      setProps(ds, ts);
      calStep();
    };

    /* times, split so a long list is scannable */
    var buildTimes = function (k) {
      var body = q("[data-td-cal-tbody]"), wrap = q("[data-td-cal-times]");
      var lbl = q("[data-td-cal-datelabel]");
      var list = (calState.slots && calState.slots[k]) || [];
      if (lbl) lbl.textContent = "Times on " + fmtDate(k);
      if (!body || !wrap) return;
      var am = list.filter(function (t) { return parseInt(t, 10) < 12; });
      var pm = list.filter(function (t) { return parseInt(t, 10) >= 12; });
      var out = "";
      var group = function (label, items) {
        if (!items.length) return "";
        return '<div class="pv-cal__gh">' + label + '</div><div class="pv-cal__tg">' +
          items.map(function (t) {
            return '<button type="button" class="pv-cal__time" data-time="' + t + '">' +
                   fmtTime(t) + "</button>";
          }).join("") + "</div>";
      };
      out += group("Morning", am) + group("Afternoon", pm);
      body.innerHTML = out || '<p class="pv-cal__none">No times left on this day.</p>';
      wrap.hidden = false;
    };

    /* week-aligned month grid, with a divider if the window crosses a month */
    var buildCal = function () {
      var grid = q("[data-td-cal-grid]"), load = q("[data-td-cal-load]");
      var mh = q("[data-td-cal-mh]"), next = q("[data-td-cal-next]");
      if (!grid) return;
      var days = Object.keys(calState.slots || {}).filter(function (k) {
        return calState.slots[k].length;
      }).sort();
      if (!days.length) {
        if (load) load.textContent = "No fitting times available in the next month.";
        return;
      }
      var first = new Date(days[0] + "T00:00:00");
      var last = new Date(days[days.length - 1] + "T00:00:00");

      if (mh) {
        var mt = MON[first.getMonth()] + " " + first.getFullYear();
        if (first.getMonth() !== last.getMonth()) {
          mt = MSH[first.getMonth()] + " \u2013 " + MSH[last.getMonth()] + " " + last.getFullYear();
        }
        q("[data-td-cal-month]").textContent = mt;
        var tot = days.reduce(function (a, k) { return a + calState.slots[k].length; }, 0);
        q("[data-td-cal-count]").textContent =
          days.length + " days \u00b7 " + tot + " slot" + (tot === 1 ? "" : "s");
        mh.hidden = false;
      }
      if (next) {
        next.innerHTML = "<b>Next available</b> " + fmtDate(days[0]) + ", " +
                         fmtTime(calState.slots[days[0]][0]);
        /* deliberately NOT data-date / data-time: those are how day and time
           buttons are matched, and this chip sitting above them in the DOM
           would be found first by both selectors. */
        next.dataset.nextDate = days[0];
        next.dataset.nextTime = calState.slots[days[0]][0];
        next.hidden = false;
      }

      var html = "";
      DIN.forEach(function (d) { html += '<span class="pv-cal__dh">' + d + "</span>"; });
      for (var pad = 0; pad < first.getDay(); pad++) html += '<span class="pv-cal__d is-off"></span>';
      var curM = first.getMonth();
      for (var cur = new Date(first); cur <= last; cur.setDate(cur.getDate() + 1)) {
        if (cur.getMonth() !== curM) {
          curM = cur.getMonth();
          html += '<span class="pv-cal__ms">' + MON[curM] + "</span>";
          for (var p2 = 0; p2 < cur.getDay(); p2++) html += '<span class="pv-cal__d is-off"></span>';
        }
        var k = isoOf(cur), n = (calState.slots[k] || []).length;
        html += n
          ? '<button type="button" class="pv-cal__d" data-date="' + k + '">' +
            "<b>" + cur.getDate() + "</b><i>" + MSH[cur.getMonth()] + "</i><em>" + n + "</em></button>"
          : '<span class="pv-cal__d is-off"><b>' + cur.getDate() + "</b><i>" +
            MSH[cur.getMonth()] + "</i><em>" +
            (cur.getDay() === 0 ? "Closed" : "Full") + "</em></span>";
      }
      grid.innerHTML = html;
      grid.hidden = false;
      if (load) load.hidden = true;
    };

    var loadSlots = function () {
      if (!cal || calState.loading) return;
      var want = qtyNow();
      if (calState.loadedQty === want) return;
      calState.loading = true;
      var load = q("[data-td-cal-load]"), err = q("[data-td-cal-err]");
      var grid = q("[data-td-cal-grid]"), times = q("[data-td-cal-times]");
      var mh = q("[data-td-cal-mh]"), next = q("[data-td-cal-next]");
      if (load) { load.hidden = false; load.textContent = "Loading available times\u2026"; }
      if (err) err.hidden = true;
      if (grid) grid.hidden = true;
      if (times) times.hidden = true;
      if (mh) mh.hidden = true;
      if (next) next.hidden = true;
      calState.date = null; calState.time = null;
      confirmSlot();

      var base = cal.dataset.endpoint;
      fetch(base + (base.indexOf("?") > -1 ? "&" : "?") + "qty=" + want,
            { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          if (!data || !data.slots) throw new Error("no slots");
          calState.slots = data.slots;
          calState.loadedQty = want;
          buildCal();
        })
        .catch(function () {
          if (load) load.hidden = true;
          if (err) err.hidden = false;
        })
        .then(function () { calState.loading = false; });
    };

    if (cal) {
      /* one listener for the whole panel; no inline handlers */
      cal.addEventListener("click", function (e) {
        var jump = e.target.closest ? e.target.closest("[data-td-cal-next]") : null;
        if (jump && cal.contains(jump)) {
          var d1 = cal.querySelector('[data-date="' + jump.dataset.nextDate + '"]');
          if (d1) d1.click();
          var t1 = cal.querySelector('[data-time="' + jump.dataset.nextTime + '"]');
          if (t1) t1.click();
          return;
        }
        var day = e.target.closest ? e.target.closest("[data-date]") : null;
        if (day && cal.contains(day)) {
          [].forEach.call(cal.querySelectorAll("[data-date]"),
            function (x) { x.classList.remove("is-on"); });
          day.classList.add("is-on");
          calState.date = day.dataset.date;
          calState.time = null;
          buildTimes(calState.date);
          confirmSlot();
          return;
        }
        var t = e.target.closest ? e.target.closest("[data-time]") : null;
        if (t && cal.contains(t)) {
          [].forEach.call(cal.querySelectorAll("[data-time]"),
            function (x) { x.classList.remove("is-on"); });
          t.classList.add("is-on");
          calState.time = t.dataset.time;
          confirmSlot();
        }
      });
    }

    /* show it only for Fitted, and clear the booking when they switch back */
    var syncService = function (isFitted) {
      if (!cal) return;
      cal.hidden = !isFitted;
      if (isFitted) {
        loadSlots();
      } else {
        calState.date = null;
        calState.time = null;
        var times = q("[data-td-cal-times]");
        if (times) times.hidden = true;
        [].forEach.call(cal.querySelectorAll(".is-on"),
          function (x) { x.classList.remove("is-on"); });
        confirmSlot();
      }
    };

    /* ---------- quantity -------------------------------------------------- */
    var qty = root.querySelector("[data-td-qty]");
    var step = function (n) {
      if (!qty) return;
      var v = parseInt(qty.value, 10);
      if (isNaN(v)) v = 1;
      qty.value = Math.max(1, v + n);
      qty.dispatchEvent(new Event("change", { bubbles: true }));
      if (cal && !cal.hidden) loadSlots();
    };
    var minus = root.querySelector("[data-td-minus]");
    var plus = root.querySelector("[data-td-plus]");
    if (minus) minus.addEventListener("click", function () { step(-1); });
    if (plus) plus.addEventListener("click", function () { step(1); });

    /* ---------- related tyres ---------------------------------------------
       Two panels, one renderer. "In this size" asks Shopify's own predictive
       search; "More from this pattern" reads a tag-filtered collection. Both
       are lazy: nothing is fetched until the panel is actually opened, because
       most visitors never open either.                                       */
    var money = function (cents) {
      return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    var relCard = function (it) {
      var img = it.img
        ? '<img src="' + it.img + '" alt="" width="70" height="70" loading="lazy">'
        : '<span class="pv-relc__noimg" aria-hidden="true"></span>';
      var flags = "";
      if (/\bZRF\b|RUN\s?FLAT|\bRFT\b/i.test(it.title)) {
        flags += '<span class="pv-relc__flag">Run-flat</span>';
      }
      if (!it.available) flags += '<span class="pv-relc__flag is-out">Sold out</span>';
      /* An ordered-in tyre in this list is labelled rather than hidden -- it
         is still a tyre we can get, it just is not on the shelf. Never
         "sold out": inventory is not tracked on those, so they are always
         buyable. */
      if (it.orderedIn) flags += '<span class="pv-relc__flag is-oi">Ordered in</span>';
      /* pattern direction matters when you are choosing between tyres of the
         same size: a directional tyre cannot be swapped side to side. */
      var meta = it.meta
        ? '<span class="pv-relc__m">' + it.meta + "</span>" : "";
      return '<a class="pv-relc" href="' + it.url + '">' + img +
        '<span class="pv-relc__t"><b>' + it.title + "</b>" + meta +
        (flags ? '<span class="pv-relc__flags">' + flags + "</span>" : "") +
        "</span>" +
        '<span class="pv-relc__p">' + it.price + "</span></a>";
    };

    var relRender = function (box, items, emptyMsg) {
      if (!items.length) {
        box.innerHTML = '<p class="pv-rel__none">' + emptyMsg + "</p>";
        return;
      }
      box.innerHTML = '<div class="pv-relg">' + items.map(relCard).join("") + "</div>";
    };

    var relLoad = function (box) {
      if (box.dataset.tdDone) return;
      box.dataset.tdDone = "1";
      var kind = box.dataset.tdRel;
      var skip = box.dataset.exclude;

      if (kind === "size") {
        /* The feed rather than /search/suggest.json. Predictive search carries
           no metafields -- so the panel could not say whether a tyre is
           directional -- and it matches loosely enough to return a 155R12 for
           a 205/55R16 query. The feed has the real size field and the real
           metafields, so the match is exact. */
        var wantSize = (box.dataset.size || "").toUpperCase().replace(/\s+/g, "");
        var sizeHits = [], allSeen = [];
        var readSize = function (n) {
          return fetch("/collections/all?view=json&page=" + n)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              (data.products || []).forEach(function (x) {
                if (x.handle === skip) return;
                allSeen.push(x);
                var mf = (x.metafields || {}).custom || {};
                var sz = String(mf.size || "").toUpperCase().replace(/\s+/g, "");
                if (sz && sz === wantSize) sizeHits.push(x);
              });
              var more = data.page && data.page.has_next;
              /* the fallback searches the whole catalogue, so on an ordered-in
                 page the walk cannot stop at eight exact matches. A normal page
                 keeps the old early exit and the same number of requests. */
              var wantsNear = box.dataset.onlyStock === "1";
              if (more && n < 6 && (wantsNear || sizeHits.length < 8)) return readSize(n + 1);
              return sizeHits;
            });
        };

        readSize(1)
          .then(function (ps) {
            /* Nothing on the shelf in the exact size. Rather than an empty
               panel, offer what a fitter would accept: the same rim, overall
               diameter within 5%, width within 20mm where we can manage it.
               Anything outside that is a different tyre, not an alternative,
               so it is left out. */
            var onlyStock = box.dataset.onlyStock === "1";
            if (onlyStock) ps = ps.filter(function (x) { return x.ordered_in !== true; });
            var near = false;
            /* ordered-in pages only. On a normal product page this panel keeps
               its old behaviour exactly -- an exact-size list, or the line
               saying this is the only one we stock in the size. */
            if (!ps.length && onlyStock) {
              var wantD = parseFloat(box.dataset.diam) || 0;
              var wantW = parseFloat(box.dataset.width) || 0;
              var wantR = parseFloat(box.dataset.rim) || 0;
              if (wantD && wantR) {
                near = true;
                ps = allSeen.filter(function (x) {
                  if (x.handle === skip) return false;
                  if (onlyStock && x.ordered_in === true) return false;
                  var m = (x.metafields || {}).custom || {};
                  if (parseFloat(m.rim_in_) !== wantR) return false;
                  var d = parseFloat(m.diameter); if (!d) return false;
                  return Math.abs(d - wantD) / wantD <= 0.05;
                }).map(function (x) {
                  var m = (x.metafields || {}).custom || {};
                  x._dw = Math.abs((parseFloat(m.width) || 0) - wantW);
                  x._dd = Math.abs((parseFloat(m.diameter) || 0) - wantD) / wantD;
                  return x;
                }).sort(function (a, b) {
                  /* width within 20mm first, then closest overall diameter */
                  var aIn = a._dw <= 20, bIn = b._dw <= 20;
                  if (aIn !== bIn) return aIn ? -1 : 1;
                  return a._dd - b._dd;
                });
              }
            }
            var intro = box.previousElementSibling;
            if (near && intro && ps.length) {
              intro.innerHTML = "<strong>Nothing on our shelf in this exact size.</strong> " +
                "These are the closest we hold — same " + box.dataset.rim +
                "&Prime; rim, and within 5% of the overall diameter, so the " +
                "speedo and the guards stay right.";
            }
            /* Our own stock first, ordered-in tyres after it. Taylor has
               asked for this on every surface that lists tyres: someone
               looking at an ordered-in page should see what is on the shelf
               before more of what is not. Within each group the feed's own
               order is kept, which is cheapest first. */
            ps.sort(function (a, b) {
              return (a.ordered_in === true) - (b.ordered_in === true);
            });
            relRender(box, ps.slice(0, 8).map(function (x) {
              var mf = (x.metafields || {}).custom || {};
              var bits = [];
              if (mf.pattern_direction_type) bits.push(mf.pattern_direction_type);
              if (mf.pattern_type) bits.push(mf.pattern_type);
              if (mf.wet_grip) bits.push("wet grip " + mf.wet_grip);
              return { title: x.title, url: x.url,
                       price: x.price_formatted || money(x.price),
                       img: x.image || "", available: x.available !== false,
                       orderedIn: x.ordered_in === true,
                       meta: bits.join(" · ") };
            }), onlyStock
                 ? "We do not have anything close enough to this size on the shelf right now."
                 : "This is the only tyre we stock in this size right now.");
          })
          .catch(function () {
            relRender(box, [], "Could not load alternatives just now.");
          });
        return;
      }

      /* pattern: the collection JSON view, filtered on the metafield.
         No tag needed -- templates/collection.json.liquid exposes
         custom.pattern, so the match is on the real field rather than on
         something duplicated into a tag that can drift out of step. */
      var want = (box.dataset.pattern || "").trim().toLowerCase();

      /* The feed pages at 250 and /collections/all holds more than that, so one
         request misses the tail of the catalogue. Walk the pages until the feed
         says there are no more, or until we have the 8 matches we can show.
         Capped at 6 pages so a mis-set page size can never loop away. */
      var matched = [];
      var readPage = function (n) {
        /* No Accept header. Shopify 404s a collection URL that asks for
           application/json -- it hands those to its own /products.json routes
           and never renders the ?view=json template. This is why the panel has
           said "could not load" since the day it was built. */
        return fetch("/collections/all?view=json&page=" + n)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            (data.products || []).forEach(function (x) {
              if (x.handle === skip) return;
              var mfp = ((x.metafields || {}).custom || {}).pattern;
              if (mfp && String(mfp).trim().toLowerCase() === want) matched.push(x);
            });
            var more = data.page && data.page.has_next;
            if (more && matched.length < 24 && n < 6) return readPage(n + 1);
            return matched;
          });
      };

      /* Same tread is a fitment question, not a shopping one: someone is asking
         which wheel this tread comes for. So the rows carry rim size, the
         recommended rim width range and the tyre's own width and sidewall, and
         they sort by rim rather than by whatever order the feed returned. */
      var num = function (v) { var n = parseFloat(v); return isFinite(n) ? n : 0; };
      var treadRow = function (x) {
        var mf = (x.metafields || {}).custom || {};
        var size = mf.size || x.title;
        var ls = [mf.load_rating || "", mf.speed_rating || ""].join("").trim();
        var rim = num(mf.rim_in_);
        var range = mf.recommended_rim_range || mf.rim_width_range || "";
        var w = mf.width ? mf.width + "mm" : "";
        var sw = mf.sidewall_mm_ ? mf.sidewall_mm_ + "mm" : "";
        var dims = [w ? "W " + w : "", sw ? "H " + sw : ""].filter(Boolean).join("  ·  ");
        var brand = [x.vendor || "", mf.pattern || ""].filter(Boolean).join(" ");

        return '<a class="pv-trd" href="' + x.url + '">' +
          '<span class="pv-trd__s">' + size +
            (ls ? ' <i>' + ls + "</i>" : "") +
            '<b>' + brand + "</b></span>" +
          '<span class="pv-trd__m">' +
            (rim ? '<span class="pv-trd__rim">' + rim + '"</span>' : "") +
            (range ? '<span class="pv-trd__k">Fits rim</span><span class="pv-trd__v">' +
                     range + "</span>" : "") +
            (dims ? '<span class="pv-trd__k">Tyre</span><span class="pv-trd__v">' +
                    dims + "</span>" : "") +
          "</span>" +
          '<span class="pv-trd__p">' + (x.price_formatted || money(x.price)) +
            (x.available === false ? '<em>Sold out</em>' : "") + "</span></a>";
      };

      readPage(1)
        .then(function (ps) {
          if (!ps.length) {
            box.innerHTML = '<p class="pv-rel__none">No other sizes of this ' +
                            "pattern in stock.</p>";
            return;
          }
          /* smallest rim first, then narrowest -- the order someone scanning
             for their own wheel size would expect */
          ps.sort(function (a, b) {
            var ma = (a.metafields || {}).custom || {}, mb = (b.metafields || {}).custom || {};
            return (num(ma.rim_in_) - num(mb.rim_in_)) || (num(ma.width) - num(mb.width));
          });
          box.innerHTML = '<div class="pv-trdl">' +
                          ps.slice(0, 12).map(treadRow).join("") + "</div>";
        })
        .catch(function () {
          relRender(box, [], "Could not load other sizes just now.");
        });
    };

    /* ---------- contact forms ---------------------------------------------
       Used by the Payment and Returns panels. Posts to Shopify /contact through
       a hidden iframe.

       This mirrors td-p-quote exactly, because that one demonstrably delivers
       and my first attempt did not. The differences that mattered:

         * the form is built ONCE and left in the DOM. Creating it, appending it
           and calling submit() in the same tick is not reliable -- the target
           iframe may not be resolved yet.
         * accept-charset="UTF-8" and the utf8 tick field, which is what Shopify
           form handling expects.

       And the success message now waits for the iframe to load rather than
       announcing itself the instant submit() is called. That earlier version
       said "on its way" whether or not anything had been accepted, which is
       worse than saying nothing.                                             */
    var cforms = root.querySelectorAll("[data-td-cform]");
    if (cforms.length && !window.tdCFormReady) {
      window.tdCFormReady = true;

      var cfFrame = document.createElement("iframe");
      cfFrame.name = "td-cform-target";
      cfFrame.setAttribute("aria-hidden", "true");
      cfFrame.tabIndex = -1;
      cfFrame.style.cssText =
        "position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none";
      document.body.appendChild(cfFrame);

      var cfForm = document.createElement("form");
      cfForm.method = "post";
      cfForm.action = "/contact#contact_form";
      cfForm.target = "td-cform-target";
      cfForm.setAttribute("accept-charset", "UTF-8");
      cfForm.style.cssText =
        "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden";
      var cfField = function (n, v) {
        var i = document.createElement("input");
        i.type = "hidden"; i.name = n; i.value = v || "";
        cfForm.appendChild(i);
        return i;
      };
      cfField("form_type", "contact");
      cfField("utf8", "\u2713");
      var cfEmail = cfField("contact[email]", "");
      var cfName = cfField("contact[name]", "");
      var cfPhone = cfField("contact[phone]", "");
      var cfBody = document.createElement("textarea");
      cfBody.name = "contact[body]";
      cfForm.appendChild(cfBody);
      document.body.appendChild(cfForm);

      window.tdCFormSend = null;   /* set per click, read by the load handler */
      cfFrame.addEventListener("load", function () {
        /* fires when Shopify has answered. The iframe is cross-document from
           our point of view, so we cannot read the response -- but a load at
           all means the post completed rather than being dropped. */
        if (window.tdCFormSend) { window.tdCFormSend(); window.tdCFormSend = null; }
      });

      [].forEach.call(cforms, function (box) {
        var btn = box.querySelector("[data-cf-send]");
        var status = box.querySelector("[data-cf-status]");
        if (!btn) return;

        var get = function (k) { return box.querySelector("[data-cf=" + k + "]"); };
        var val = function (el) { return el ? el.value.trim() : ""; };
        var say = function (msg, kind) {
          if (!status) return;
          status.textContent = msg;
          status.className = "pv-cform__status is-" + kind;
          status.hidden = false;
        };

        btn.addEventListener("click", function () {
          var name = get("name"), email = get("email"), body = get("body");

          if (!val(name) || !val(email) || !val(body)) {
            say("Please fill in your name, email and message.", "err");
            return;
          }
          if (val(email).indexOf("@") < 1 || val(email).indexOf(".") < 0) {
            say("That email address does not look right.", "err");
            return;
          }

          var subject = box.dataset.cfSubject || "Product page enquiry";
          cfName.value = val(name);
          cfEmail.value = val(email);
          cfPhone.value = subject;
          cfBody.value = [val(body), "", "--", subject, document.title,
                          window.location.href].join("\n");

          btn.disabled = true;
          say("Sending\u2014", "wait");

          var done = false;
          window.tdCFormSend = function () {
            done = true;
            btn.disabled = false;
            say("Thanks, that has been sent. We will come back to you shortly.", "ok");
            if (name) name.value = "";
            if (email) email.value = "";
            if (body) body.value = "";
          };
          /* if nothing comes back, say so rather than leaving a spinner */
          setTimeout(function () {
            if (done) return;
            btn.disabled = false;
            window.tdCFormSend = null;
            say("That did not go through. Please ring us on (07) 573 9090 " +
                "or email email@tyredispatch.co.nz.", "err");
          }, 12000);

          try {
            cfForm.submit();
          } catch (e) {
            done = true;
            btn.disabled = false;
            say("Could not send just now. Please ring us on (07) 573 9090.", "err");
          }
        });
      });
    }

    /* ---------- fitting tab -> the buy box ---------------------------------
       The panel does not carry a calendar any more. Ticking the fitted option
       is what reveals the real one, so do that first, then bring it into view;
       scrolling to a hidden calendar would look like nothing happened.        */
    var goFit = root.querySelector("[data-td-gofit]");
    if (goFit) {
      goFit.addEventListener("click", function () {
        var fitted = root.querySelector("[data-td-fitted] input[type=radio]");
        var box = root.querySelector(".pv-svc") || root.querySelector(".pv-buy");
        if (fitted && !fitted.checked) {
          fitted.checked = true;
          fitted.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (box && box.scrollIntoView) {
          box.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }

    /* ---------- conditions today ------------------------------------------
       Falls back to the static wet-grip figures already on the panel when no
       endpoint is set, so the tab is useful before the Worker exists.        */
    var cond = root.querySelector("[data-td-cond]");
    if (cond) {
      var cbody = cond.querySelector("[data-td-cond-body]");
      var ep = cond.dataset.endpoint;
      var band = function (s) {
        if (s >= 85) return ["Good conditions", "is-good"];
        if (s >= 70) return ["Drive with care", "is-fair"];
        if (s >= 50) return ["Caution advised", "is-poor"];
        return ["Hazardous", "is-bad"];
      };
      cond.addEventListener("click", function (e) {
        var chip = e.target.closest ? e.target.closest("[data-town]") : null;
        if (!chip || !cond.contains(chip)) return;
        if (!ep) return;                    /* no endpoint: let the link work */
        e.preventDefault();
        [].forEach.call(cond.querySelectorAll("[data-town]"),
          function (x) { x.classList.remove("is-on"); });
        chip.classList.add("is-on");
        cbody.innerHTML = '<p class="pv-rel__load">Checking conditions in ' +
                          chip.dataset.town + "\u2026</p>";
        var qs = "?city=" + encodeURIComponent(chip.dataset.town) +
                 "&grade=" + encodeURIComponent(cond.dataset.grade || "") +
                 "&tread=" + encodeURIComponent(cond.dataset.tread || "") +
                 "&type=" + encodeURIComponent(cond.dataset.type || "") +
                 "&dir=" + encodeURIComponent(cond.dataset.dir || "");
        fetch(ep + qs, { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (x) {
            var bm = band(x.score), bt = band(x.baseline);
            cbody.innerHTML =
              '<div class="pv-cond__now"><b>' + x.summary + "</b><span>" + x.detail + "</span>" +
              '<em>' + chip.dataset.town + " \u00b7 " + x.updated + "</em></div>" +
              '<div class="pv-cond__sc">' +
                '<div class="pv-cond__s"><span>A typical worn set</span><b>' + x.baseline +
                  '</b><i class="' + bt[1] + '">' + bt[0] + '</i><em>Grade C at 4mm</em></div>' +
                '<div class="pv-cond__s is-mine"><span>With these fitted</span><b>' + x.score +
                  '</b><i class="' + bm[1] + '">' + bm[0] + '</i><em>' + x.tyre + "</em></div>" +
              "</div>" +
              '<p class="pv-cond__line">' + x.line + "</p>" +
              '<p><a href="' + cond.dataset.report + "?city=" +
                encodeURIComponent(chip.dataset.town) + '">Full report for ' +
                chip.dataset.town + " \u2192</a></p>";
          })
          .catch(function () {
            cbody.innerHTML = '<p class="pv-rel__none">Could not reach the conditions ' +
              'service. The figures below hold whatever the weather.</p>';
          });
      });
    }

    /* fetch a related panel only once its tab is opened */
    var relBoxes = [].slice.call(root.querySelectorAll("[data-td-rel]"));
    if (relBoxes.length) {
      var maybeLoad = function () {
        relBoxes.forEach(function (b) {
          if (b.offsetParent !== null) relLoad(b);
        });
      };
      root.addEventListener("click", function () { setTimeout(maybeLoad, 60); });
      setTimeout(maybeLoad, 300);
    }

    /* ---------- dispatch countdown ----------------------------------------
       Counts to the cut-off in the SHOP's timezone, not the visitor's, or an
       Australian customer is told the wrong thing. Past the cut-off it rolls
       to the next weekday rather than showing a negative.                   */
    var box = root.querySelector("[data-td-countdown]");
    var clock = root.querySelector("[data-td-clock]");
    if (box && clock) {
      var cutoff = parseInt(box.dataset.cutoff, 10) || 12;
      var tick = function () {
        var nzNow = new Date(new Date().toLocaleString("en-US", { timeZone: "Pacific/Auckland" }));
        var target = new Date(nzNow);
        target.setHours(cutoff, 0, 0, 0);
        while (target <= nzNow || target.getDay() === 0 || target.getDay() === 6) {
          target.setDate(target.getDate() + 1);
          target.setHours(cutoff, 0, 0, 0);
        }
        var s = Math.floor((target - nzNow) / 1000);
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
        clock.textContent = h + "h " + m + "m " + (s % 60) + "s";
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  var boot = function () {
    [].forEach.call(document.querySelectorAll("[data-td-product]"), init);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  /* the theme editor re-renders a section without reloading the page */
  document.addEventListener("shopify:section:load", boot);
})();
